import React, { useRef, useEffect, useState } from 'react';
import {
  Avatar,
  useChannelActionContext,
  useChannelStateContext,
  useChatContext,
} from 'stream-chat-react';
import { channelByUser } from '../ChannelSearch/utils';
import { useHistory } from 'react-router-dom';

import './TeamChannelHeader.css';

import { ChannelInfo, PinIcon } from '../../_assets';

function useOutsideAlerter(ref, setShowMemberList) {
  useEffect(() => {
    /**
     * Alert if clicked on outside of element
     */
    function handleClickOutside(event) {
      if (ref.current && !ref.current.contains(event.target)) {
        setShowMemberList(false);
      }
    }
    // Bind the event listener
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [ref]);
}

export const TeamChannelHeader = ({ setIsEditing, setPinsOpen }) => {
  const { client, setActiveChannel } = useChatContext();
  const { closeThread } = useChannelActionContext();
  const { channel, watcherCount } = useChannelStateContext();
  const history = useHistory();
  const teamHeader = `# ${channel.data.name || channel.data.id || 'random'}`;

  const getMessagingHeader = () => {
    const [showMembers, setShowMembers] = useState(false);
    // const toggleShowMembers = () => setShowMembers(!showMembers);
    const wrapperRef = useRef(null);
    useOutsideAlerter(wrapperRef, setShowMembers);
    const members = Object.values(channel.state.members).filter(
      ({ user }) => user.id !== client.userID
    );
    const additionalMembers = members.length - 3;

    if (!members.length) {
      return (
        <div className='team-channel-header__name-wrapper'>
          <Avatar image={null} size={32} />
          <p className='team-channel-header__name user'>Admin</p>
        </div>
      );
    }

    return (
      <div className='team-channel-header__name-wrapper'>
        {channel?.data?.room_type === 'group' && (
          <div
            className='team-channel-group-header'
            onClick={() => {
              history.push({
                pathname: `/job-dashboardv2/update-job-group/${channel.id}`,
              });
            }}
          >
            <Avatar
              image={channel.data.image}
              name={channel.data.name || channel.data.id}
              size={45}
            />
            <div className='team-channel-header__title__container'>
              <p className='team-channel-header__title user'>
                {channel.data.name || ''}
              </p>
              <p className='team-channel-header__subtitle user'>
                {channel?.data?.additionalDetails?.header_subtitle || ''}
              </p>
            </div>
          </div>
        )}
        {members.map(({ user }, i) => {
          if (i > 2) return null;
          return (
            <div key={i} className='team-channel-header__name-multi'>
              <Avatar
                image={user.image}
                name={user.name || user.id}
                size={32}
              />
              {channel?.data?.room_type !== 'group' && (
                <p className='team-channel-header__name user'>
                  {user.name || user.id}
                </p>
              )}
            </div>
          );
        })}
        {additionalMembers > 0 && (
          <p
            onClick={() => {
              setShowMembers(true);
            }}
            className='team-channel-header__name  team-channel-header__name__relative  user'
          >
            {`and ${additionalMembers} more`}

            {channel?.data?.room_type === 'group' && showMembers && (
              <div
                ref={wrapperRef}
                className='team-channel-header__members__container '
              >
                {members.map(({ user }, i) => {
                  return (
                    <div
                      onClick={async () => {
                        channelByUser({
                          client,
                          setActiveChannel,
                          channel,
                          user,
                        });
                      }}
                      key={i}
                      className='team-channel-header__name-multi team-channel-header__members__container__item '
                    >
                      <Avatar
                        image={user.image}
                        name={user.name || user.id}
                        size={32}
                      />
                      <p className='team-channel-header__name user'>
                        {user.name || user.id}
                      </p>
                    </div>
                  );
                })}
              </div>
            )}
          </p>
        )}
      </div>
    );
  };

  const getWatcherText = (watchers) => {
    if (!watchers) return 'No users online';
    if (watchers === 1) return '1 user online';
    return `${watchers} users online`;
  };

  return (
    <div className='team-channel-header__container'>
      {channel.type === 'messaging' ? (
        getMessagingHeader()
      ) : (
        <div className='team-channel-header__channel-wrapper'>
          <p className='team-channel-header__name'>{teamHeader}</p>
          <span style={{ display: 'flex' }} onClick={() => setIsEditing(true)}>
            <ChannelInfo />
          </span>
        </div>
      )}
      <div className='team-channel-header__right'>
        <p className='team-channel-header__right-text'>
          {getWatcherText(watcherCount)}
        </p>
        <div
          className='team-channel-header__right-pin-wrapper'
          onClick={(e) => {
            closeThread(e);
            setPinsOpen((prevState) => !prevState);
          }}
        >
          <PinIcon />
          <p className='team-channel-header__right-text'>Pins</p>
        </div>
      </div>
    </div>
  );
};
